module.exports = __webpack_public_path__ + "img/ufollowus-workflow.fd653d61.svg";